import React from 'react';
import { Button, ButtonSize } from '@benzinga/core-ui';
import styled from '@benzinga/themetron';

interface Props {
  link?: string;
  size?: ButtonSize;
}

export const QuoteFreeAlertButton: React.FC<Props> = ({ link, size }) => {
  return (
    <Container
      className="free-alert-button-container"
      data-action="Click Free Alert"
      href={link}
      rel="noreferrer"
      target="_blank"
    >
      <Button className="free-alert-button" size={size} variant="warning">
        Get Free Alerts
      </Button>
    </Container>
  );
};

export default QuoteFreeAlertButton;

const Container = styled.a`
  &.free-alert-button-container {
    display: inline-flex;
  }
`;
